/* eslint-disable */

/** unique or primary key constraints on table "argo.log_category" */
export enum ArgoLogCategoryConstraint {
  /** unique or primary key constraint on columns "category" */
  LogCategoryPkey = 'log_category_pkey'
}

export enum ArgoLogCategoryEnum {
  /** Argonaut */
  Argonaut = 'argonaut',
  /** Device */
  Device = 'device',
  /** MES App */
  MesApp = 'mes_app',
  /** Other */
  Other = 'other',
  /** Service */
  Service = 'service',
  /** Spearhead */
  Spearhead = 'spearhead'
}

/** select columns of table "argo.log_category" */
export enum ArgoLogCategorySelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description'
}

/** update columns of table "argo.log_category" */
export enum ArgoLogCategoryUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description'
}

